import React from 'react';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { createRoot } from 'react-dom/client';
import { PayApp } from './components/PayApp';
import { globals } from './utils/globals';
import { Panorama } from './utils/panorama';
import { baseParams, ComponentId } from './utils/panorama/config';

Panorama.init({
  ...baseParams,
  componentId: ComponentId.CashierPaymentsApp,
  msid: window.__WIX_IDENTITIES__?.msid,
  uuid: window.__WIX_IDENTITIES__?.visitorId,
});

experimentsService.init(globals.experiments);

const root = createRoot(document.getElementById('root'));
root.render(<PayApp />);
